import axios from "axios";
import { CityType } from "models/city_type";
import { ContatoType } from "models/contato_type";
import { OrderType } from "models/order_type";
import { PessoaType } from "models/person_type";
import { ProjectContact } from "models/project_contact_type";
import { UsuarioModel } from "models/user_model";
import { useEffect, useRef, useState } from "react";

const useLaunchProject = () => {
  const [list1, setList] = useState<OrderType[]>([]);
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [usuarios, setUsuarios] = useState<UsuarioModel[]>([
    {
      ativo: false,
      email: "",
      id: "",
      idEmpresa: "",
      nome: "",
      senha: "",
      telefone: "",
      Permissao: [],
    },
    {
      ativo: false,
      email: "",
      id: "",
      idEmpresa: "",
      nome: "",
      senha: "",
      telefone: "",
      Permissao: [],
    },
    {
      ativo: false,
      email: "",
      id: "",
      idEmpresa: "",
      nome: "",
      senha: "",
      telefone: "",
      Permissao: [],
    },
    {
      ativo: false,
      email: "",
      id: "",
      idEmpresa: "",
      nome: "",
      senha: "",
      telefone: "",
      Permissao: [],
    },
  ]);
  const [error, setError] = useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [selectedOrder1, setSelectedOrder] = useState<OrderType>(null);
  const [show1, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [clients, setClientes] = useState<PessoaType[]>([]);
  const [faturamento, setFaturamento] = useState<PessoaType>();
  const [contrato, setContrato] = useState<PessoaType>();
  const [descricao, setDescricao] = useState("");
  const [linkDiretor, setLinkDiretor] = useState("");
  const [linkDrive, setLinkDrive] = useState("");
  const [linkFinalizacao, setLinkFinalizacao] = useState("");
  const [linkCronograma, setLinkCronogram] = useState("");
  const [resumoCronograma, setResumoCronograma] = useState("");
  const [notasInternas, setNotasInternas] = useState("");
  const [notasCliente, setNotasCliente] = useState("");
  const [instrucaoContrato, setInstrucaoContrato] = useState("");
  const [linkPO, setLinkPO] = useState("");
  const [users, setUsers] = useState<UsuarioModel[]>([]);
  const [cidades, setCidades] = useState<CityType[]>([]);
  const [insertCity, setInsertCity] = useState<CityType>(null);
  const [contatoCliente1, setContatoCliente] = useState<ContatoType>(null);
  const [contatoAgencia1, setContatoAgencia] = useState<ContatoType>(null);
  const [contatoList1, setcontatoList1] = useState<ProjectContact[]>([]);
  const [responsavelFinanceiro, setResponsavelFinceiro] =
    useState<ProjectContact>();
  const [responsavelJuridico, setResponsavelJuridico] =
    useState<ProjectContact>();
  const [insertContact, setInsertContact] = useState<ProjectContact>(null);
  const contactRef = useRef(null);
  const cityRef = useRef(null);
  const cancelRef = useRef(null);

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };
  const closeError = () => {
    setError(false);
  };

  const stateSetterMap: any = {
    descricao: setDescricao,
    linkDiretor: setLinkDiretor,
    linkDrive: setLinkDrive,
    linkFinalizacao: setLinkFinalizacao,
    resumoCronograma: setResumoCronograma,
    notasInternas: setNotasInternas,
    notasCliente: setNotasCliente,
    instrucaoContrato: setInstrucaoContrato,
    linkPO: setLinkPO,
    linkCronograma: setLinkCronogram
  };

  const changeInput = (tipo: string, value: any) => {
    const setter = stateSetterMap[tipo];
    if (setter) {
      setter(value);
    }
  };

  const showModal1 = async (show: boolean, item: OrderType) => {
    if (show) {
      setSelectedOrder(item);
      if (item?.contatoAgencia) {
        await loadAgencia(item?.contatoAgencia);
      }
      if (item?.contatoCliente) {
        await loadClient(item?.contatoCliente);
      }
    }
    setShow(show);
  };

  const loadOrder = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/projeto/orcamento/aprovado/" +
      userData?.idEmpresa +
      "/4"
    );
    if (response.data) {
      setList(response.data);
    }
  };

  const loadClients = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/pessoa/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setClientes(response.data);
    }
  };

  const loadUsers = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/user/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setUsers(response.data);
    }
  };

  const changeCity = (tipo: string, value: any) => {
    switch (tipo) {
      case "cidade":
        setInsertCity({ ...insertCity, cidade: value });
        break;
      case "estado":
        setInsertCity({ ...insertCity, estado: value });
        break;
      case "diarias":
        setInsertCity({ ...insertCity, diarias: Number(value) });
        break;

      default:
        break;
    }
  };

  const addCity = (item: CityType) => {
    const existe = cidades.find(
      (a) => a.cidade === item.cidade && a.estado === item.estado
    );
    if (!existe) {
      setCidades([...cidades, item]);
      setInsertCity(null);
      cityRef.current.focus();
    }
  };

  const editCity = (
    item: CityType,
    index: number,
    tipo: string,
    valor: any
  ) => {
    const newItems: CityType[] = cidades.map((existingItem, idx) => {
      if (index === idx) {
        switch (tipo) {
          case "cidade":
            item.cidade = valor;
            break;
          case "estado":
            item.estado = valor;
            break;
          case "diarias":
            item.diarias = Number(valor);
            break;
        }
        return item;
      }

      return existingItem;
    });

    setCidades(newItems);
  };

  const removeCity = (item: CityType) => {
    const existe = cidades.filter((a) => a !== item);
    setCidades(existe);
    cityRef.current.focus();
  };

  const loadContact = async (id: string) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/projeto/contato/" + id
    );
    if (response.data) {
      return response.data;
    }
  };

  const loadAgencia = async (id: string) => {
    const ca = await loadContact(id);
    if (ca) {
      setContatoAgencia(ca);
    }
  };
  const loadClient = async (id: string) => {
    const cl = await loadContact(id);
    if (cl) {
      setContatoCliente(cl);
    }
  };

  const changeContact = (
    property: string,
    value: any,
    classificacao: string
  ) => {
    setInsertContact((prevContact) => ({
      ...prevContact,
      [property]: value,
      tipo: classificacao,
    }));
  };

  const chageTipo = (classificacao: string) => {
    setInsertContact({ ...insertContact, tipo: classificacao });
  };

  const addContact = (item: ProjectContact) => {
    const existe = contatoList1.find(
      (a) =>
        a.nome === item.nome && a.email === item.email && a.tipo === item.tipo
    );
    if (!existe) {
      setcontatoList1([...contatoList1, item]);
      setInsertContact(null);
      //contactRef.current.focus();
    }
  };

  const editContact = (
    item: ProjectContact,
    index: number,
    tipo: string,
    valor: any
  ) => {
    const newItems: ProjectContact[] = contatoList1.map((existingItem, idx) => {
      if (index === idx) {
        switch (tipo) {
          case "nome":
            item.nome = valor;
            break;
          case "cargo":
            item.cargo = valor;
            break;
          case "email":
            item.email = valor;
            break;
          case "telefone":
            item.telefone = valor;
            break;
        }
        return item;
      }

      return existingItem;
    });

    setcontatoList1(newItems);
  };

  const removeContact = (item: ProjectContact) => {
    const existe = contatoList1.filter((a) => a !== item);
    setcontatoList1(existe);
    // contactRef.current.focus();
  };

  const addUser = (userId: string, index: number) => {
    //confirmar com o brunao se a mesma pessoa pode fazer parte de dois papeis.

    const existe = users.find((a) => a.id === userId);
    const newUsers: UsuarioModel[] = [...usuarios];
    let item = newUsers[index];
    item = existe;
    newUsers.splice(index, 1, item);
    setUsuarios(newUsers);
  };

  const changeRespFinanceiro = (tipo: string, value: string) => {
    switch (tipo) {
      case "nome":
        setResponsavelFinceiro({
          ...responsavelFinanceiro,
          nome: value,
          tipo: "respFinan",
        });
        break;
      case "cargo":
        setResponsavelFinceiro({
          ...responsavelFinanceiro,
          cargo: value,
          tipo: "respFinan",
        });
        break;
      case "email":
        setResponsavelFinceiro({
          ...responsavelFinanceiro,
          email: value,
          tipo: "respFinan",
        });
        break;

      case "telefone":
        setResponsavelFinceiro({
          ...responsavelFinanceiro,
          telefone: value,
          tipo: "respFinan",
        });
        break;

      default:
        break;
    }
  };

  const changeRespJuridico = (tipo: string, value: string) => {
    switch (tipo) {
      case "nome":
        setResponsavelJuridico({
          ...responsavelJuridico,
          nome: value,
          tipo: "respJuridico",
        });
        break;
      case "cargo":
        setResponsavelJuridico({
          ...responsavelJuridico,
          cargo: value,
          tipo: "respJuridico",
        });
        break;
      case "email":
        setResponsavelJuridico({
          ...responsavelJuridico,
          email: value,
          tipo: "respJuridico",
        });
        break;

      case "telefone":
        setResponsavelJuridico({
          ...responsavelJuridico,
          telefone: value,
          tipo: "respJuridico",
        });
        break;

      default:
        break;
    }
  };

  const changeFaturamento = (item: string) => {
    const p = clients.find((a) => a.id === item);
    setFaturamento(p)
  }

  const changeContrato = (item: string) => {
    const p = clients.find((a) => a.id === item);
    setContrato(p)
  }
  const reloadDataClients = async () => {
    await loadClients();

  }


  const validate = () => {
    const requiredFields = [
      { field: descricao.length === 0, message: "Preencha Corretamente a Descrição do Projeto" },
      { field: usuarios.find((u) => u.id === ''), message: "Preencha Corretamente os responsáveis pelo projeto" },
      // { field: cidades.length === 0, message: "Preencha ao menos uma cidade para o projeto" },
      { field: linkDiretor.length === 0, message: "Preencha o Link / Anexo do Tratamento do Diretor(a)" },
      { field: linkDrive.length === 0, message: "Preencha o Link pasta Executiva no Drive" },
      { field: linkFinalizacao.length === 0, message: "Preencha o Link pasta Finalização no Drive" },
      { field: resumoCronograma.length === 0, message: "Preencha o Resumo Cronograma" },
      { field: notasInternas.length === 0, message: "Preencha as Notas Internas" },
      { field: notasCliente.length === 0, message: "Preencha as Notas sobre Agência/Cliente" },
      { field: instrucaoContrato.length === 0, message: "Preencha as Instruções sobre Faturamento e Contrato" },
      { field: linkPO.length === 0, message: "Preencha o Link de PO, Ficha de cadastro ou Arquivo Relevante" },
      { field: faturamento === null, message: "Preencha os dados de Faturamento" },
      { field: contrato === null, message: "Preencha os dados de Contrato" },
      { field: responsavelFinanceiro === null, message: "Preencha os dados do Responsável Financeiro" },
      { field: responsavelJuridico === null, message: "Preencha os dados de Responsável Jurídico" },
    ];

    const hasError = requiredFields.some((field) => {
      if (field.field) {
        showError("Erro!", field.message);
        return true;
      }
      return false;
    });

    return !hasError;
  };

  const updateStatusOrder = async () => {
    const response = await axios.patch(
      process.env.REACT_APP_API_URL + "/projeto/orcamento/status/" + selectedOrder1.id + "/5"

    );
    if (response.data) {
      showModal1(false, selectedOrder1);
    }

  }

  const save = async () => {

    let newData = [...contatoList1];
    newData.push(responsavelFinanceiro, responsavelJuridico);
    if (!validate()) {
      return;
    }

    setLoading(true);

    const projectData: any = {
      aprovado: true,
      aprovadoCalculo: true,
      dataCriacao: null,
      dataEdicao: null,
      descricao,
      idEmpresa: usuario?.idEmpresa,
      linkCronograma,
      linkDiretor,
      linkPastaExecutiva: linkFinalizacao,
      linkPastaFinalizacao: linkFinalizacao,
      notasClienteAgencia: notasCliente,
      notasFaturamento: instrucaoContrato,
      notasInternas: notasInternas,
      orcamentoId: selectedOrder1.id,
      resumoCronograma,
      usuarioId: usuario?.id,
    };

    const response = await axios.post(process.env.REACT_APP_API_URL + '/projeto', projectData);

    if (response) {
      const newProject = response.data;

      const postAprovadores = async () => {
        for (let i = 0; i < usuarios.length; i++) {
          const itemUser = usuarios[i];
          const data = {
            projetoId: newProject.id,
            usuarioId: itemUser.id,
            nivel: i,
          };
          await axios.post(process.env.REACT_APP_API_URL + '/projeto/aprovador', data);
        }
      };

      const postCidades = async () => {
        if (cidades.length > 0) {
          for (let i = 0; i < cidades.length; i++) {
            const itemCity = cidades[i];
            const data = {
              projetoId: newProject.id,
              cidade: itemCity.cidade,
              estado: itemCity.estado,
              diarias: itemCity.diarias,
            };
            await axios.post(process.env.REACT_APP_API_URL + '/projeto/cidade', data);
          }
        }
      };

      const postContatos = async (contatoList: any) => {
        for (let i = 0; i < contatoList.length; i++) {
          const itemContato = contatoList[i];
          const data = {
            projetoId: newProject.id,
            nome: itemContato.nome,
            cargo: itemContato.cargo,
            telefone: itemContato.telefone,
            tipo: itemContato.tipo,
            email: itemContato.email,
            principal: false,
            ativo: true,
          };
          await axios.post(process.env.REACT_APP_API_URL + '/projeto/contato', data);
        }
      };

      const postPessoas = async (personList: any) => {
        for (let i = 0; i < personList.length; i++) {
          const person = personList[i];
          const data = {
            projetoId: newProject.id,
            pessoaId: person.id,
          };
          await axios.post(process.env.REACT_APP_API_URL + '/projeto/pessoa', data);
        }
      };

      await Promise.all([postAprovadores(), postCidades()]);

      if (newData.length > 0) {
        await postContatos(contatoList1);
      }

      const list: PessoaType[] = [faturamento, contrato];
      await postPessoas(list);

      await updateStatusOrder();
    }

    showModal1(false, selectedOrder1);
    setLoading(false);
    newData = [];
    setcontatoList1([]);

    await loadOrder();
  };

  useEffect(() => {
    const loadData = async () => {
      await loadOrder();
      await loadClients();
      await loadUsers();
    };

    loadData();
  }, []);

  return {
    list1,
    usuario,
    showModal1,
    show1,
    selectedOrder1,
    loading,
    clients,
    changeInput,
    descricao,
    users,
    cidades,
    insertCity,
    changeCity,
    addCity,
    removeCity,
    editCity,
    contatoAgencia1,
    contatoCliente1,
    contatoList1,
    insertContact,
    changeContact,
    addContact,
    editContact,
    removeContact,
    contactRef,
    cityRef,
    chageTipo,
    usuarios,
    addUser,
    changeRespFinanceiro,
    changeRespJuridico,
    error,
    errorMsg,
    errorTitle,
    cancelRef,
    closeError,
    save,
    showError,
    reloadDataClients,
    changeFaturamento,
    changeContrato,
    faturamento,
    contrato
  };
};

export default useLaunchProject;
